module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Light TH.9b6ee81c.woff2";